import { Component } from "react"
import PropTypes from "prop-types"
import { Button, Paper, Tab, Tabs } from "@mui/material"
import { SaveAlt } from "@mui/icons-material"
import SideSheet from "components/material/side-sheet"
import LoadingWrapper from "components/loading-wrapper"
import TradesLoading from "./components/trades-loading"
import TradesError from "./components/trades-error"
import Trades from "./components/trades"
import { formatLongDate } from "helpers/formatters/dates"
import ExcelDownload from "components/excel-download"
import "./style.scss"

class TradesPanel extends Component {
  static propTypes = {
    selectedDate: PropTypes.string.isRequired,
    portfolioName: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    fileName: PropTypes.string.isRequired,
    csvRows: PropTypes.array.isRequired,
    tradeType: PropTypes.string.isRequired,
    trades: PropTypes.array.isRequired,
    openSecurityProfile: PropTypes.func.isRequired,
    openCompositeSecurity: PropTypes.func.isRequired,
    setOpenTradeId: PropTypes.func.isRequired,
    openTradeId: PropTypes.string,
    openFactorProfile: PropTypes.func.isRequired,
    toggleTrades: PropTypes.func.isRequired,
    tradesOpened: PropTypes.bool.isRequired,
    setTradeType: PropTypes.func.isRequired,
    toggleSaveExperiment: PropTypes.func.isRequired,
    saveEnabled: PropTypes.bool,
  }

  onTabChanged = (_, value) => {
    const { setTradeType } = this.props
    setTradeType(value)
  }

  render() {
    const {
      selectedDate,
      portfolioName,
      status,
      fileName,
      csvRows,
      tradeType,
      trades,
      openSecurityProfile,
      openCompositeSecurity,
      setOpenTradeId,
      openTradeId,
      openFactorProfile,
      toggleTrades,
      tradesOpened,
      saveEnabled,
      toggleSaveExperiment,
    } = this.props

    const loadingComponent = <TradesLoading />
    const errorComponent = <TradesError text="There was an error while loading the trades. Please try again." />

    return <SideSheet open={tradesOpened} title="Trades" subheader={`${formatLongDate(selectedDate)} - ${portfolioName}`} onClose={toggleTrades}>
      <div className="components_trades-panel">
        <LoadingWrapper status={[status]} loadingComponent={loadingComponent} errorComponent={errorComponent}>
          <ExcelDownload icon={<SaveAlt />} data={csvRows} location="Simulator Trades" fileName={fileName} className="download" />
          <Paper elevation={0}>
            <Tabs
              value={tradeType}
              onChange={this.onTabChanged}
              className="trade-type"
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab value="buy" label="Buy" />
              <Tab value="sell" label="Sell" />
              <Tab value="short" label="Short" />
              <Tab value="cover" label="Buy to Cover" />
              <Tab value="all" label="All Positions" />
            </Tabs>
          </Paper>
          <Trades
            trades={trades}
            openTradeId={openTradeId}
            setOpenTradeId={setOpenTradeId}
            openSecurityProfile={openSecurityProfile}
            openFactorProfile={openFactorProfile}
            openCompositeSecurity={openCompositeSecurity}
          />
          {saveEnabled
            && <div className="buttons-bar">
              <Button onClick={toggleSaveExperiment} className="save-compare" variant="contained" color="primary">Save Experiment</Button>
            </div>}
        </LoadingWrapper>
      </div>
    </SideSheet>
  }
}

export default TradesPanel
